<script lang="ts">
  export let error: string;
</script>

<div>
  <small>{error}</small>
</div>

<style>
  small {
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    margin: 15px 0px 0px 0px;
    color: #eb3b5a;
  }
</style>
